<section *ngIf="!homeView" class="background wrapper bg-light">
    <div class="container py-14 py-md-16">
      <div  class="column gx-lg-8 gx-xl-12 gy-10 align-items-center">
        <div class="col-lg-4 title-container">
          <h2 class="fs-15 text-uppercase text-line text-primary text-center mb-3">Meet the Team</h2>
        </div>

        <div class="col-lg-8" style="width: 100%;">
            <div class="team-container" >

                <div class="employee-container"  *ngFor="let employee of employees ; let i = index">
                  <div class="card">
                    <div class="card-body">
                      <img *ngIf="employee?.page?.url" class="rounded-circle image-size mb-4" dynamicImage  [baseImageSrc]="employee?.page?.url" [displayResolutions]="[IMAGES_RESOLUTIONS.xxs, IMAGES_RESOLUTIONS.xs]" src="{{employee?.page?.url}}" alt="{{'employee' + i}}" />
                      <img *ngIf="!employee?.page?.url" class="rounded-circle image-size mb-4"  src="/assets/images/thumbnail.png" alt="{{'employee' + i}}" />
                      <h4 class="mb-1">{{employee?.firstName}} {{employee?.lastName}}</h4>
                      <div class="meta mb-2">{{employee?.page?.role}}</div>
                      <p class="mb-2" [innerHTML]="employee?.page?.description"></p>
                    </div>
                  </div>
                </div>
            </div>
        </div>
      </div>
    </div>
</section>


<section *ngIf="homeView" class="team-home-view-container center wrapper pattern-wrapper bg-image section-frame default-background overflow-hidden">
    <div class="container default-background">
      <div class="row gx-lg-0 gy-10 align-items-center text-inverse">
        <div class="col-lg-6">
            <figure><img class="img-auto rounded"dynamicImage *ngIf="landingPageData?.meetTheTeam?.img" [baseImageSrc]="landingPageData?.meetTheTeam?.img" [displayResolutions]="[IMAGES_RESOLUTIONS.xxs, IMAGES_RESOLUTIONS.xs]"  alt="solutionsImg" /></figure>
        </div>
        <div class="col-lg-5 ms-lg-auto">
          <h2 class="display-2 mb-3 text-white">{{landingPageData?.meetTheTeam?.title}}</h2>
          <p class="lead fs-lg pe-lg-5">{{landingPageData?.meetTheTeam?.description}}</p>
          <div class="btn-container">
            <a routerLink="/about-us" class="btn btn-primary rounded-xl mb-0 border-none">About Us</a>
          </div>
        </div>
      </div>
    </div>
</section>


